var React = require('react');

function TriangleHeaderBgMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M300.227 254.342L254.191 2.29347M300.227 254.342L163.236 140.203M300.227 254.342L5.46451 110.806M254.191 2.29347L163.236 140.203M254.191 2.29347L5.46451 110.806M163.236 140.203L5.46451 110.806","stroke":"#543D6B"}));
}

TriangleHeaderBgMobile.defaultProps = {"width":"289","height":"266","viewBox":"0 0 289 266","fill":"none"};

module.exports = TriangleHeaderBgMobile;

TriangleHeaderBgMobile.default = TriangleHeaderBgMobile;
